import TransitApi from './base'

export default {
  // Listar roles con paginación
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/role/list?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Obtener total de roles
  async getTotal() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/role/get-total')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Obtener detalles de un rol
  async getById(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/role/details/${id}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Crear o actualizar rol
  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id ? `/role/details/${params.id}` : '/role/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Eliminar rol
  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/role/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },

  // Obtener menús asignados a un rol
  async getMenus(roleId) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/role/${roleId}/menus`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Asignar menús a un rol
  async assignMenus(roleId, menuIds) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post(`/role/${roleId}/menus`, { menuIds })
      return result
    } catch (error) {
      return error.response
    }
  },
}
